module.exports = __webpack_public_path__ + "static/media/review1.e4e0a8fd.svg";